/**
 * マイページのカード間リアルタイム反映用のカスタムイベント定義。
 *
 * 日払い依頼 / 打刻修正 などの操作直後に、 関連カード (給与明細 / 給与分析 / 勤務分析) を
 * リロード無しで再フェッチさせるための window CustomEvent をやり取りする。
 * 購読側は useEmployeeScopedRefresh フックを使い、 detail.employeeId が自分と一致するときだけ反応する。
 */

/** 日払い依頼の作成 / 取消など、 給与 (日払い) 状態が変わったときに発火 */
export const CAST_PAYROLL_UPDATED = 'logme_payroll_updated';

/**
 * 打刻修正など勤怠が変わったときに発火 (既存 AttendanceEditModal が同名イベントを dispatch 済)。
 * 勤務時間が変わると給与計算にも影響するため、 給与系カードもこのイベントを購読する。
 */
export const CAST_ATTENDANCE_UPDATED = 'logme_attendance_updated';

/**
 * 日払い依頼の作成成功などで給与状態が変わったことを通知する。
 * employeeId を必ず載せ、 購読側 (useEmployeeScopedRefresh) が自分宛てのときだけ再フェッチできるようにする。
 */
export function emitPayrollUpdated(
  employeeId: number | string | null | undefined,
  attendanceId?: number | null,
): void {
  if (typeof window === 'undefined') return;
  const empNum = Number(employeeId);
  // employeeId が不明だと購読側が fail-closed で無視するため、 有効値のときだけ発火する。
  if (!Number.isFinite(empNum) || empNum <= 0) return;
  try {
    window.dispatchEvent(
      new CustomEvent(CAST_PAYROLL_UPDATED, {
        detail: { employeeId: empNum, attendanceId: attendanceId ?? null },
      }),
    );
  } catch {
    // ignore
  }
}

/**
 * 出勤・退勤の打刻など、勤怠が変わったことを通知する（2026-09-29）。
 * 以前は打刻修正（AttendanceEditModal）だけが発火していたので、出勤打刻をしても出勤履歴に今日の行が出ず、
 * 画面を開き直すまで勤務中の出勤時刻を「打刻修正」できなかった。
 * employeeId を必ず載せる（購読側は自分宛てのときだけ再フェッチする）。
 */
export function emitAttendanceUpdated(
  employeeId: number | string | null | undefined,
  attendanceId?: number | null,
): void {
  if (typeof window === 'undefined') return;
  const empNum = Number(employeeId);
  if (!Number.isFinite(empNum) || empNum <= 0) return;
  try {
    window.dispatchEvent(
      new CustomEvent(CAST_ATTENDANCE_UPDATED, {
        detail: { employeeId: empNum, attendanceId: attendanceId ?? null },
      }),
    );
  } catch {
    // ignore
  }
}
